import React from 'react';

import { CustomAlert } from 'components/AlertsCollection';
import EditButton, { SelectedTemplate } from 'components/Admin/Mailer/Templates/TemplateList/List/Item/EditButton';
import DeleteButton from 'components/Admin/Mailer/Templates/TemplateList/List/Item/DeleteButton';

import './index.scss';

// type/subType são `any` para espelhar exatamente o contrato do Item do desktop
// (que repassa os objetos inteiros para EditButton/DeleteButton). Mantemos o mesmo
// comportamento, só trocando o layout de linha (Row/Col) por card.
interface MailerTemplateCardProps {
  type: any,
  subType: any,
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectedTemplate: React.Dispatch<React.SetStateAction<SelectedTemplate | null>>,
  setAlerts: React.Dispatch<React.SetStateAction<CustomAlert[]>>,
}

export default function TemplateCard({
  type, subType, setModalOpen, setSelectedTemplate, setAlerts,
}: MailerTemplateCardProps) {
  return (
    <div className="template-card">
      <dl className="template-card-meta">
        <div>
          <dt>Tipo</dt>
          <dd>{type.label}</dd>
        </div>
        <div>
          <dt>Subtipo</dt>
          <dd>{subType.label}</dd>
        </div>
      </dl>
      <div className="template-card-actions">
        <EditButton
          type={type}
          subType={subType}
          setModalOpen={setModalOpen}
          setSelectedTemplate={setSelectedTemplate}
        />
        <DeleteButton
          type={type}
          subType={subType}
          setAlerts={setAlerts}
        />
      </div>
    </div>
  );
}
